import { useEffect, useRef, useState } from "react";
import { useLocation } from "wouter";

export function NavigationProgress() {
  const [location] = useLocation();
  const [width, setWidth] = useState(0);
  const [visible, setVisible] = useState(false);
  const isFirst = useRef(true);

  useEffect(() => {
    if (isFirst.current) {
      isFirst.current = false;
      return;
    }
    setVisible(true);
    setWidth(8);
    const t1 = setTimeout(() => setWidth(35), 80);
    const t2 = setTimeout(() => setWidth(65), 250);
    const t3 = setTimeout(() => setWidth(95), 500);
    const t4 = setTimeout(() => setWidth(100), 800);
    const t5 = setTimeout(() => { setVisible(false); setWidth(0); }, 1100);
    return () => {
      clearTimeout(t1); clearTimeout(t2); clearTimeout(t3);
      clearTimeout(t4); clearTimeout(t5);
    };
  }, [location]);

  if (!visible) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-[3px] pointer-events-none">
      <div
        className="h-full bg-primary transition-all ease-out"
        style={{ width: `${width}%`, transitionDuration: width === 8 ? "0ms" : "300ms" }}
      />
    </div>
  );
}
